import {
  getCurriculumMapsForContextUrl,
  getUpsertCurriculumMapUrl,
  updateCurriculumMapTermUrl,
} from "../config/Config";
import { getRequest, putRequest } from "./ServiceHelper";

export class CurriculumMapService {
  static getCurriculumMapsByContextId = (contextId) => {
    return getRequest(getCurriculumMapsForContextUrl(contextId));
  };

  static upsertCurriculumMap = (curriculumMap, contextId) => {
    const body = { curriculumMap: curriculumMap, contextId: contextId };
    return putRequest(getUpsertCurriculumMapUrl(), body);
  };

  static updateCurriculumMapTerm = (mapId, termId) => {
    const params = { termId };
    return putRequest(updateCurriculumMapTermUrl(mapId), params);
  };
}
